import { useDedupEffect } from "@npd-ng/adp-component-library";
import { useSelector } from "react-redux";
import * as img from "shared/assets";
import { IADPState } from "./AppStateTypes";
type imageType = {
  src: string,
  altText: string
}

export function useImagePreloader() {
    const textContent = useSelector(
      (state: { rootState: IADPState }) => state.rootState.currentLanguageContent?.imageAltText
    );
    const imageUrls: imageType[]=[
      {src:img.greenCheck,altText:textContent?.successIcon || "Success Icon"},
      {src:img.redTriangleExclamation,altText:textContent?.failureTriangleIcon || "Failure Icon"},
      {src:img.error,altText:textContent?.failureCircleIcon || "Failure Icon"},
      {src:img.questionMark,altText:textContent?.questionMarkIcon || "Question Mark Icon"},
      {src:img.raiseHand,altText:textContent?.raiseHandIcon || "Raise Hand Icon"},
      {src:img.normal16,altText:textContent?.verificationActionIcon || "Verification Action Icon"},
      {src:img.normal98,altText:textContent?.assessmentDayActionIcon || "Assessment Day Icon"},
      {src:img.plugIcon,altText:textContent?.plugIcon || "Plug Icon"}
    ]
    useDedupEffect(() => {
      const images:HTMLImageElement[] = [];
      imageUrls.forEach((image:imageType) => {
        const img:HTMLImageElement = new Image();
        img.src = image.src;
        img.alt= image.altText
        images.push(img);
      });
  
      return () => {
        images.forEach((img) => {
          img.onload = null;
        });
      };
    }, [imageUrls]);
  }